import { isCookiebotAnalyticsConsentGiven } from "@/utils/analytics/cookiebot";

export const isClarityAvailable = (): boolean => {
  return (
    typeof window !== "undefined" &&
    isCookiebotAnalyticsConsentGiven() &&
    typeof window.clarity === "function"
  );
};

export const safeClarityEvent = (eventName: string): void => {
  if (!isClarityAvailable()) {
    console.debug(`Clarity event skipped (not available): ${eventName}`);
    return;
  }

  try {
    window.clarity?.("event", eventName);
  } catch (error) {
    console.error(`Error sending Clarity event "${eventName}":`, error);
  }
};

// Safe wrapper for Clarity.identify
export const safeClarityIdentify = (
  email: string,
  customSessionId?: string,
  customPageId?: string,
  friendlyName?: string,
): void => {
  if (!isClarityAvailable()) {
    console.debug("Clarity identify skipped (not available)", {
      email,
      customSessionId,
      customPageId,
      friendlyName,
    });
    return;
  }

  try {
    window.clarity?.(
      "identify",
      email,
      customSessionId,
      customPageId,
      friendlyName,
    );
  } catch (error) {
    console.error("Error calling Clarity identify:", error);
  }
};

// Safe wrapper for Clarity.setTag
export const safeClaritySetTag = (key: string, value: string): void => {
  if (!isClarityAvailable()) {
    console.debug(`Clarity setTag skipped (not available): ${key}`, value);
    return;
  }

  try {
    window.clarity?.("set", key, value);
  } catch (error) {
    console.error(`Error setting Clarity tag "${key}":`, error);
  }
};
